import CrmActivities from "./CrmActivities";
import CrmAutomations from "./CrmAutomations";
import CrmCalendar from "./calendar/CrmCalendar";
import { AreaOrders, AreaSubscriptions } from "@/components/area/AreaModules";
import CrmContacts from "./CrmContacts";
import CrmKpi from "./CrmKpi";
import CrmLeads from "./CrmLeads";
import CrmLeadSources from "./CrmLeadSources";
import CrmMembers from "./CrmMembers";
import CrmOutbox from "./CrmOutbox";
import CrmPipeline from "./CrmPipeline";
import CrmSheet from "./CrmSheet";
import CrmTrash from "./CrmTrash";
import SupportRequests from "@/components/area/SupportRequests";
import AreaPlan from "@/components/area/AreaPlan";

const ALL = ["support", "owner", "manager", "editor", "viewer"];

// [key, label, Component, roles, module] shared by the ADM Studio (/crm) and the client member area (/area); module = shown only when the client uses it
export const CRM_TABS = [["sheet", "Tabella", CrmSheet, ALL], ["leads", "Richieste", CrmLeads, ALL], ["contacts", "Contatti", CrmContacts, ALL], ["pipeline", "Pipeline", CrmPipeline, ALL],
  ["activities", "Attività", CrmActivities, ALL],
  ["calendar", "Calendario", CrmCalendar, ALL, "bookings"], ["orders", "Ordini", AreaOrders, ALL, "shop"], ["subscriptions", "Abbonamenti", AreaSubscriptions, ALL, "subscriptions"],
  ["kpi", "Indicatori", CrmKpi, ALL], ["automations", "Automazioni", CrmAutomations, ALL], ["sources", "Fonti lead", CrmLeadSources, ALL], ["members", "Membri", CrmMembers, ALL],
  ["support", "Richieste a MUSORA", SupportRequests, ["support"]], ["plan", "Piano", AreaPlan, ["support"]],
  ["trash", "Cestino", CrmTrash, ["support", "owner", "manager"]], ["outbox", "Email", CrmOutbox, ["support"]]];

export const CRM_GROUPS = [["Panoramica e vendite", ["sheet", "leads", "contacts", "pipeline", "activities"]], ["Operazioni", ["calendar", "orders", "subscriptions"]],
  ["Analisi e gestione", ["kpi", "automations", "sources", "members", "support", "plan", "trash", "outbox"]]];
